export const API_SERVER = 'https://myap-api.baovietnhantho.com.vn/ap-myap/api/v1/'
